import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import styled from 'styled-components';
import api from '../../../api/req';
import { AppContext } from '../../../providers/authProvider';
import CreateRole from './createRole';
import UpdateRole from './updateRole';
import { CloseButton, Button } from '../../../components/Styled/Buttons';
import { Modal } from '../../../components/Styled/Misc/Modal';
import { ErrorMessage, DimmableLoader } from '../../../components/Styled/Misc';

const ButtonContainer = styled.div`
margin-left: auto`;

const H2 = styled.h2`
  ${({ color }) => `color: ${color}`}`;

const StyledButton = styled.button`
border: none;
text-decoration: none;
background: inherit;
cursor: pointer;
font-size: 14px
`;

function Editor() {
  const { auth } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [list, setList] = useState(null);
  const [show, setShow] = useState(false);
  const [updateList, switchUpdateList] = useState(false);
  const [res, setRes] = useState(null);
  const [openUpdatePage, setOpenUpdatePage] = useState(null);
  const [activeId, setActiveId] = useState(null);

  const onLoadStart = useCallback(() => {
    setLoading(true);
    setErr(null);
  }, []);

  const onLoadEnd = useCallback(() => {
    setLoading(false);
  }, []);
  const onError = useCallback((e) => setErr(e), []);

  useEffect(() => {
    const loader = async () => {
      const r = await api.get('/api/role/', auth);
      if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
      return r.json();
    };
    onLoadStart();
    loader()
      .then((rData) => {
        setList(rData);
      })
      .catch((e) => onError(e.message))
      .finally(() => onLoadEnd());
  }, [auth, onError, onLoadEnd, onLoadStart, updateList]);

  const deleteRole = useCallback((id) => {
    const loader = async () => {
      const r = await api.delete(`/api/role/${id}`, auth);
      if (r.status === 204) {
        switchUpdateList(!updateList);
        return 'Видалено успішно';
      }
      if (r.status === 400) {
        const error = await r.json();

        error.error_data.map((e) => {
          if (e.messages) {
            throw new Error(`${r.status}: ${e.messages}`);
          }
          return error.error_data;
        });

        return error.error_data;
      }
      if (!r.ok) throw new Error(`${r.status}: ${r.statusText}`);

      return r.json();
    };
    onLoadStart();
    loader()
      .then((rData) => {
        setRes(rData);
      })
      .catch((e) => onError(e.message))
      .finally(() => onLoadEnd());
  }, [auth, onError, onLoadEnd, onLoadStart, updateList]);

  const handleOpenedUpdatePage = useCallback((id) => {
    setActiveId(id);
    setOpenUpdatePage(true);
  }, []);

  return (
    <DimmableLoader loading={loading}>
      {err && (
      <ErrorMessage text={err} />
      )}

      {res && (
      <H2 dismissible color="green">
        {res}
      </H2>
      )}
      {list
        && (
          <>
            <Modal open={show} size="xl">
              <>
                <ButtonContainer>
                  <CloseButton onClick={() => setShow(false)} />
                </ButtonContainer>
                <CreateRole onClose={() => setShow(false)} setUpdateList={switchUpdateList} />
              </>
            </Modal>

            <Modal open={openUpdatePage} size="xl">
              <>
                <ButtonContainer>
                  <CloseButton onClick={() => setOpenUpdatePage(false)} />
                </ButtonContainer>
                <UpdateRole
                  onClose={() => setOpenUpdatePage(false)}
                  activeId={activeId}
                  setUpdateList={switchUpdateList}
                />
              </>
            </Modal>

            <H2 color="#00e7ff">Список ролей:</H2>

            <table>
              <tbody>
                {list.results.map((el) => (
                  <tr key={el.id}>
                    <td style={{ width: '20%' }}>
                      <StyledButton type="button" onClick={() => handleOpenedUpdatePage(el.id)}>{el.name}</StyledButton>
                    </td>
                    <td>
                      <StyledButton type="button" onClick={() => handleOpenedUpdatePage(el.id)}>{el.description}</StyledButton>
                    </td>
                    <td style={{ width: '5px' }}>
                      <Button variant="outline-danger" onClick={() => deleteRole(el.id)} content="Видалити" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div>
              <Button onClick={() => setShow(true)} className="mt-2" content="Створити" />
            </div>
          </>
        )}
    </DimmableLoader>
  );
}

export default Editor;
